<template>
  <div id="home">
    <div class="homeWrap">
      <div class="logoTitle">
        <p><strong>中国足球协会信息化平台教练员培训管理系统</strong></p>
      </div>
      <div class="moduleWrap" v-if="!isFive">
        <div class="moduleUp">
          <router-link class="linkA" to="/organization/training_course_list">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="users-cog" scale="3.5"></v-icon>
              </div>
              <p>培训班管理</p>
            </div>
          </router-link>
          <router-link class="linkA" to="/organization/EnrollList">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="user-plus" scale="3.5"></v-icon>
              </div>
              <p>注册教练员</p>
              <div class="tips" v-if="Number(transferNum) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ transferNum | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/organization/train_registration_manager">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="chalkboard-teacher" scale="4"></v-icon>
              </div>
              <p>高端培训报名</p>
              <div class="tips" v-if="Number(enrollCheckNum) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ enrollCheckNum | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA"
            :to="{ path: 'documents', query: { idx:2,object_type:'organ' } }">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="regular/file-alt" scale="3.5"></v-icon>
              </div>
              <p>文件存档</p>
            </div>
          </router-link>
        </div>
        <div class="moduleDown">
          <router-link class="linkA" to="/organization/evaluation_list">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="file-signature" scale="4"></v-icon>
              </div>
              <p>问卷调查</p>
              <div class="tips" v-if="Number(eva_status_N) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ eva_status_N | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/organization/all_stus_tutorial">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="clipboard-list" scale="4"></v-icon>
              </div>
              <p>学员教案</p>
            </div>
          </router-link>
          <router-link class="linkA" to="/organization/punish_people">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-cog" scale="4"></v-icon>
              </div>
              <p>处罚管理</p>
            </div>
          </router-link>
          <router-link
            class="linkA"
            to="/display-club"
          >
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="html5-c" scale="3"></v-icon>
              </div>
              <p>大数据</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="moduleWrap" v-else>
        <div class="moduleUp">
          <router-link class="linkA" to="/organization/training_course_list">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="users-cog" scale="3.5"></v-icon>
              </div>
              <p>培训班管理</p>
            </div>
          </router-link>
          <router-link class="linkA"
            :to="{ path: 'documents', query: { idx:2,object_type:'organ' } }">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="regular/file-alt" scale="3.5"></v-icon>
              </div>
              <p>文件存档</p>
            </div>
          </router-link>
        </div>
        <div class="moduleDown">
          <router-link class="linkA" to="/organization/evaluation_list">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="file-signature" scale="4"></v-icon>
              </div>
              <p>问卷调查</p>
              <div class="tips" v-if="Number(eva_status_N) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ eva_status_N | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/organization/all_stus_tutorial">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="clipboard-list" scale="4"></v-icon>
              </div>
              <p>学员教案</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <el-dialog class="eval-dialog"
      :visible.sync="allDisabled"
      title
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="460px"
      center>
      <div class="to-eval">
        <div class="img">
          <img src="@/assets/images/evaluation_tips.png" alt>
        </div>
        <div class="tips">
          <p v-html="tips.title"></p>
        </div>
        <el-button type="primary" @click="gotoSetting">{{tips.button_text}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import "vue-awesome/icons/list-alt";
  import "vue-awesome/icons/university";
  import "vue-awesome/icons/user-plus";
  import "vue-awesome/icons/user-lock";
  import "vue-awesome/icons/user-check";
  import "vue-awesome/icons/sticky-note";
  import "vue-awesome/icons/user-alt-slash";
  import "vue-awesome/icons/file-archive";
  import "vue-awesome/icons/sitemap";
  import "vue-awesome/icons/clipboard-list";
  import "vue-awesome/icons/users-cog";
  import "vue-awesome/icons/chalkboard-teacher";
  import "vue-awesome/icons/user-cog";
  import "vue-awesome/icons/regular/file-alt";
  import "vue-awesome/icons/check";
  import "vue-awesome/icons/clipboard-check";  // file-signature
  import "vue-awesome/icons/file-signature";
  import "vue-awesome/icons/comment-alt"; // 提示气泡
  import '../../../assets/js/yioks-icons'
  import fiveMixins from '@/minix/fiveMixins';
  import {enroll_personnel_num} from "@/api/ab_signup/api";
  import {evaluationNum} from "@/api/common/api";

  export default {
    name: "TrainingCourseManager",
    mixins: [fiveMixins],
    data() {
      return {
        classNum: 0,
        classScoreNum: 0,
        classApplicationNum: 0,
        eva_c_id:0,
        allDisabled: false,
        transferNum: 0,
        isDot:false,
        enrollCheckNum:0,
        eva_status_N:0,
        tips:{
          title:"",
          button_text:"",
          show_type:"",
        },
      };
    },
    computed: {
    
    },
    components: {
      "v-icon": () => import("vue-awesome/components/Icon"),
    },
    filters: {
      filterNum(num) {
        return Number(num) >= 100 ? (num = "99+") : num;
    
      },
    },
    created() {
      this.getPersonnelum();
      this.getEvaNum();
    },
    methods: {
      getEvaNum() {
        evaluationNum({})
        .then(({data})=>{
          // console.log(data);
          // 更新vuex测评数量
          if(Number(data.status) === 0 ){
            this.$store.commit("updateEvaNum", Number(data.result.eva_status_N)||0);
            this.eva_status_N = Number(data.result.eva_status_N)||0;
            // 如果是11人制 强制弹框写调查
            if(!this.isFive && data.result.eva_show_Cid && data.result.eva_show_Cid > 0){
              this.allDisabled = true ;
              this.tips.title= data.result.eva_show_CName+ "已经结束，请您填写问卷调查。";
              this.tips.button_text="前往问卷调查";
              this.tips.show_type="eva_show";
              this.eva_c_id = data.result.eva_show_Cid;
            }
          }
        })
        .catch((err)=>{
          console.error(err);
        });
      },
      getPersonnelum(){
        enroll_personnel_num({
      
        }).then(res=>{
          if (res.data.status===0){
            const {checkNum, transferNum}=res.data.result;
            this.transferNum = transferNum;
            this.enrollCheckNum=checkNum;
          } else{
            this.$message.error(res.data.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      },
      gotoSetting(){
        if(this.tips.show_type === 'survey'){
          this.$router.push({
            path: "/survey/survey_index",
            query: {survey_id:this.survey_id}
          });
        }
        else if(this.tips.show_type === 'eva_show'){
          //        this.$router.push({
          //          path: "create_evaluation",
          //          query: {c_id:this.eva_c_id}
          //        });
          this.$router.push({
            name: "OrgCreateEvaluation",
            params: { classId: this.eva_c_id }
          });
        }
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  #home
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center
    user-select none
    .homeWrap
      width 930px
      .logoTitle
        height 85px
        display flex
        flex-direction column
        justify-content center
        align-items center
        margin 0 0 40px 0
        color $color_title
        font-size 40px
        font-weight bolder
        text-shadow 2px 1px 3px #231815
      .moduleWrap
        .moduleUp, .moduleDown, .module-item
          margin 40px 0
          display flex
          justify-content space-between
          box-sizing border-box
          .linkA
            // width: 200px;
            // flex: 1 1 auto;
            flex 1
            margin 0 20px
        .moduleItem
          position relative
          width 100%
          height 200px
          display flex
          flex-direction column
          justify-content center
          align-items center
          color $color_white
          font-size 23px
          background-color $block_bg_color_base
          cursor pointer
          .icon
            display flex
            align-items center
          p
            margin 20px 0 0
        .classItem
          .tips
            position absolute
            top calc(20% - 15px)
            right calc(35% - 15px)
            .icon
              color $color_suc
            .num
              width 100%
              height 100%
              padding 2px 0 0
              position absolute
              top 0
              left 0
              text-align center
              font-size $font_size_big
  .bg
    background-color $block_bg_color_base
  .animate
    flex-basis 2
  .h200
    height 200px
  .module-item
    display flex
    .tips
      position absolute
      top calc(20% - 15px)
      right calc(35% - 15px)
      .icon
        color $color_suc
      .num
        width 100%
        height 100%
        padding 2px 0 0
        position absolute
        top 0
        left 0
        text-align center
        font-size $font_size_big
    .item-wrapper
      flex 1
      height 200px
      display flex
      .linkA
        margin 0 20px
      .hover-box-hide
        margin 0 20px
        flex 1
      .hover-box-show
        display none
      &:hover
        .hover-box-show
          display flex
          flex 1
          justify-content space-between
        .hover-box-hide
          display none
  .moduleDown
    display flex
    .tips
      position absolute
      top calc(20% - 15px)
      right calc(35% - 15px)
      .icon
        color $color_suc
      .num
        width 100%
        height 100%
        padding 2px 0 0
        position absolute
        top 0
        left 0
        text-align center
        font-size $font_size_big
  .eval-dialog
    .to-eval
      font-size 16px
      text-align center
      img
        width 100px
      .tips
        margin-bottom 15px
</style>
